var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasketIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 8.626V7.5C21 3.386 17.897 0 14 0S7 3.386 7 7.5v1.126h3V7.5C10 4.987 11.821 3 14 3c2.179 0 4 1.987 4 4.5v1.126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.896 8h16.417a2 2 0 0 1 1.95 1.557l3.636 16A2 2 0 0 1 25.95 28H2a2 2 0 0 1-1.943-2.473l3.896-16A2 2 0 0 1 5.896 8m.946 3L3.5 25h21l-3.119-14z"
  }))));
};
export default SvgBasketIcon;